export const GRID_SIZE = 40
